// This page has been temporarily removed for development. Authentication will be added later.
const Register = () => <div>Register page is disabled for now.</div>;
export default Register;
